export default "__VITE_ASSET__DTy0kZlR__"